module.exports = __webpack_public_path__ + "static/media/close_white7b66831c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/close_white.svg
// module id = 326
// module chunks = 0